import React, {
    useState,
    useEffect
} from "react";
import {
    Row,
    Col,
    Button,
    Modal,
    Form
} from "react-bootstrap";
import { getFromLS } from "../../../utils/storage";
import { FormContext } from "../../../reusable-components/InputFields/FormContext";
import Element from '../../../reusable-components/InputFields/input';
import * as Icon from "react-bootstrap-icons";
import { logout } from "../../../utils";
import { toast } from "react-toastify";
import { makeCygnusApiCall } from "../../../api/api";
import { CustomButton } from "../../../reusable-components/CustomButtonComponent/button";

export const PreviewFullWindowModal = (props) => {
    const [previewComponents, setPreviewComponents] = useState([{}])
    const [formTitle, setFormTitle] = useState("")
    const [formUrl, setFormUrl] = useState("")
    useEffect(() => {
        const newComponents = [...props.previewcomponents]
        for (let component of newComponents) {
          if(component["approval"]){
              Object.assign(component, {"show":false})
          }
        }
        setPreviewComponents(newComponents)
    }, [props.previewcomponents])
    useEffect(() => {
        setFormTitle(props.formtitle)
    }, [props.formtitle])
    useEffect(() => {
        setFormUrl(props.formurl)
    }, [props.formurl])

    useEffect(() => {
      console.log("PREVIEW COMPONENTS: ", previewComponents)
    }, [previewComponents])
    

    /**
     * Update the values of fields in the PREVIEW form
     * @param {*} field_id: ID of field to be updated 
     * @param {*} event: The trigger event of input in preview form
     */
    const handleChange = (field_id, event) => {
        const newList = [...previewComponents]
        newList.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                switch (type) {
                    case 'checkbox':
                        field['value'] = event.target.checked;
                        break;

                    case 'select':
                        field['value'] = event.value;
                        break;

                    case 'file':
                        field['value'] = event[0];
                        break;

                    case 'date':
                        field['value'] = event;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            const newListTwo = [...newList]
            setPreviewComponents(newListTwo)
        })
    }
    const [uploadDataApiFlag, setUploadDataApiFlag] = useState()
    const uploadData = async(formUrl) => {
        setUploadDataApiFlag(true)
        let payloadFormat;
        payloadFormat = {
            "Response": previewComponents
        }
        const data = await makeCygnusApiCall({
            type: "POST",
            payload: payloadFormat,
            url: `/forms/${formUrl}/`,
            show_message: false,
            customized_success_message: "Successful uploaded your response.",
            customized_failure_message: "Unable to upload your response for this form, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while uploading your response for this form, please contact support and attach a screenshot.",
            isblob: false
        })
        if (data.success) {
            props.onHide()
        }
        setUploadDataApiFlag(false)
    }
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            backdropClassName="custom-backdrop"
            centered
            className="full-modal"
            scrollable="false"
        >
            <Modal.Header className="preview-modal-header" closeButton>
            </Modal.Header>
            <Modal.Body className="preview-modal">
                <Row className='no-gutter'>
                    <Col md={1}></Col>
                    <Col md={10}>
                        <h4 style={{ margin: "10px 0px 20px 0px", textAlign: "center" }}>{formTitle}</h4>
                        <FormContext.Provider value={{ handleChange }}>
                            <Form className='no-padding'>
                                <Row className='no-gutter'>
                                    {
                                        previewComponents &&
                                        previewComponents.map((field, i) =>
                                            <Element
                                                key={i}
                                                field={field}
                                            />
                                        )
                                    }
                                </Row>
                            </Form>
                        </FormContext.Provider>
                    </Col>
                    <Col md={1}></Col>
                </Row>
                <Row className="no-gutter flex-row-center-center">
                    <CustomButton
                        progress={uploadDataApiFlag}
                        onclick={() => uploadData(formUrl)}
                        content={uploadDataApiFlag ? "Uploading information" : "Upload information"}
                        disable={uploadDataApiFlag}
                    />
                </Row>
            </Modal.Body>
            <Modal.Footer className="action-footer">
            </Modal.Footer>
        </Modal>
    )
}